import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import messages from 'routes/App/Apps/DataBrowser/translate'
import SelectList from 'components/common/SelectList'
import { fetchSiteList } from 'reducers/dataBrowser/reducer'
import { setSiteContext } from 'reducers/profile/reducer'

class SiteFilter extends Component {
  onSiteChange = value => {
    const { activeSite, setSiteContext } = this.props

    if (value && activeSite !== value.index) {
      setSiteContext({ site: value.index })
    }
  }

  componentDidMount() {
    this.props.fetchSiteList({})
  }

  componentDidUpdate(prevProps) {
    const {
      licenseeId,
      fetchSiteList,
      activeSite,
      siteList,
      setSiteContext,
    } = this.props

    if (prevProps.licenseeId !== licenseeId) {
      fetchSiteList({})
    }

    if (activeSite === 0 && siteList.size > 0) {
      const siteByDefault = siteList.get(0).id
      setSiteContext({ site: siteByDefault })
    }
  }

  render() {
    const {
      siteList,
      activeSite,
      intl: { formatMessage },
      siteListLoader,
    } = this.props

    return (
      <SelectList
        variant="outlined"
        name="site"
        label={formatMessage(messages.siteList)}
        onChange={this.onSiteChange}
        list={siteList}
        value={activeSite}
        loader={siteListLoader}
        map={{
          index: 'id',
          text: 'name',
        }}
      />
    )
  }
}

export default connect(
  state => ({
    siteList: state.getIn(['dataBrowser', 'siteList']),
    activeSite: state.getIn(['profile', 'siteId']),
    licenseeId: state.getIn(['profile', 'licenseeId']),
    siteListLoader: state.getIn(['dataBrowser', 'isLoadSiteList']),
  }),
  {
    fetchSiteList,
    setSiteContext,
  },
)(injectIntl(SiteFilter))
